import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getRealEstates, getUserKPIAvailableColumns } from './api';

export const path = '/kpi/user/list';

const PageUserKPIList: React.FC = (props) => {
  const UserKPIList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      realEstates: getRealEstates,
      columns: getUserKPIAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <UserKPIList {...props} />;
};

export default PageUserKPIList;
